// Important: Only use icons from the following packs
// - Solar (general UI elements)
// -> https://icones.js.org/collection/solar
// - Hugeicons (brands and social medias)
// -> https://icones.js.org/collection/hugeicons
// Material Design Icons (brands)
// -> https://icones.js.org/collection/mdi
// Nonicons (code languages)
// -> https://icones.js.org/collection/nonicons
// TCA icons (custom icons)
// -> ./assets/icons

const icons = {
  // General
  action: 'solar:cpu-bolt-linear',
  add: 'solar:add-circle-linear',
  addSquare: 'solar:add-square-linear',
  admin: 'solar:crown-star-linear',
  ai: 'hugeicons:artificial-intelligence-04',
  alert: 'solar:bell-linear',
  analytics: 'solar:pie-chart-2-bold-duotone',
  api: 'solar:code-square-linear',
  apiToken: 'solar:key-minimalistic-square-3-linear',
  arrowLeft: 'solar:arrow-left-linear',
  arrowPointingRight: 'solar:arrow-right-linear',
  arrowPointingTop: 'mdi:arrow-up-right',
  arrowRight: 'solar:arrow-right-linear',
  ask: 'hugeicons:ai-magic',
  attachment: 'solar:paperclip-bold',
  auth: 'solar:lock-circle-linear',
  back: 'solar:round-alt-arrow-left-linear',
  blogUrl: 'solar:notebook-square-linear',
  bookWithBookmark: 'solar:book-bookmark-linear',
  calendar: 'solar:calendar-linear',
  calendarMonth: 'solar:calendar-date-linear',
  cancel: 'solar:logout-2-linear',
  cancelAnytime: 'solar:mask-happly-linear',
  cancelUpgrade: 'solar:cart-cross-linear',
  caret: 'solar:alt-arrow-down-bold',
  check: 'solar:check-circle-linear',
  chevronDown: 'solar:alt-arrow-down-linear',
  chevronLeft: 'solar:alt-arrow-left-linear',
  chevronRight: 'solar:alt-arrow-right-linear',
  clean: 'solar:broom-bold-duotone',
  clipboard: 'solar:clipboard-list-linear',
  clipboardCheck: 'solar:clipboard-check-linear',
  close: 'solar:close-circle-linear',
  code: 'solar:programming-linear',
  coins: 'hugeicons:coins-01',
  columns: 'solar:posts-carousel-horizontal-linear',
  companies: 'solar:city-linear',
  company: 'hugeicons:building-02',
  companySimilar: 'hugeicons:building-05',
  computer: 'solar:laptop-linear',
  copy: 'solar:copy-linear',
  creditCard: 'solar:card-linear',
  dark: 'solar:moon-linear',
  dashboard: 'hugeicons:dashboard-browsing',
  data: 'solar:database-bold-duotone',
  datapoints: 'solar:database-linear',
  datapointsSimplified: 'solar:medal-ribbon-linear',
  datapointsStandard: 'solar:medal-ribbon-star-linear',
  dedicatedSupport: 'solar:chat-round-like-linear',
  default: 'solar:question-circle-linear',
  developer: 'hugeicons:developer',
  developersUrl: 'solar:chat-square-code-linear',
  docs: 'solar:sidebar-code-linear',
  docsUrl: 'solar:notebook-bookmark-linear',
  document: 'solar:document-text-linear',
  documents: 'solar:notebook-bookmark-linear',
  download: 'solar:download-minimalistic-bold',
  drag: 'solar:hamburger-menu-linear',
  edit: 'solar:pen-2-bold-duotone',
  email: 'mdi:alternate-email',
  emailResend: 'mdi:email-resend-outline',
  enterprise: 'solar:buildings-2-linear',
  error: 'solar:danger-circle-linear',
  event: 'solar:bolt-circle-broken',
  eventsUrl: 'solar:calendar-date-linear',
  fileCode: 'solar:code-file-linear',
  filter: 'solar:filter-linear',
  flag: 'solar:flag-2-linear',
  frequency: 'solar:server-square-update-linear',
  globe: 'solar:global-linear',
  history: 'solar:history-bold',
  impersonate: 'mdi:spy',
  import: 'solar:download-minimalistic-linear',
  infinity: 'solar:infinity-linear',
  info: 'solar:info-circle-linear',
  interface: 'hugeicons:browser',
  invitation: 'solar:ticket-bold-duotone',
  keyboard: 'solar:keyboard-linear',
  light: 'solar:sun-2-linear',
  link: 'solar:link-round-angle-bold',
  list: 'solar:folder-linear',
  listDynamic: 'solar:folder-favourite-star-linear',
  listExisting: 'solar:archive-up-minimlistic-linear',
  listNew: 'solar:inbox-archive-linear',
  lists: 'solar:folder-with-files-linear',
  loading: 'solar:refresh-bold-duotone',
  locations: 'solar:streets-map-point-linear',
  login: 'solar:login-linear',
  logout: 'solar:logout-linear',
  mailbox: 'solar:mailbox-line-duotone',
  map: 'solar:streets-map-point-linear',
  minus: 'solar:minus-square-linear',
  newsSites: 'solar:notebook-bookmark-linear',
  next: 'solar:alt-arrow-right-linear',
  no: 'hugeicons:check-unread-01',
  partnershipUrl: 'solar:confetti-minimalistic-linear',
  password: 'solar:lock-keyhole-minimalistic-unlocked-linear',
  passwordCheck: 'mdi:password-check-outline',
  passwordNew: 'solar:password-linear',
  passwordNewConfirm: 'solar:password-minimalistic-input-linear',
  pin: 'solar:map-point-linear',
  play: 'solar:play-bold',
  previous: 'solar:alt-arrow-left-linear',
  pricing: 'solar:dollar-minimalistic-linear',
  profile: 'solar:user-id-linear',
  rateLimit: 'hugeicons:dashboard-speed-02',
  receipt: 'solar:bill-check-linear',
  refresh: 'solar:refresh-linear',
  repeat: 'solar:repeat-bold-duotone',
  reset: 'solar:restart-linear',
  results: 'solar:list-check-bold',
  roadmap: 'solar:inbox-line-linear',
  robot: 'hugeicons:robotic',
  save: 'solar:file-download-linear',
  scaleup: 'solar:buildings-linear',
  score: 'mdi:storm-outline',
  search: 'solar:magnifer-linear',
  searchEngines: 'solar:calendar-search-linear',
  settings: 'solar:settings-linear',
  signals: 'mdi:broadcast',
  signature: 'hugeicons:signature',
  similar: 'solar:layers-minimalistic-linear',
  similarity: 'solar:copy-linear',
  similarityEngine: 'hugeicons:global-search',
  similarityHigh: 'solar:square-arrow-right-up-linear',
  similarityLow: 'solar:square-arrow-right-down-linear',
  similarityMedium: 'solar:square-arrow-right-linear',
  sitemapUrl: 'solar:document-text-linear',
  skip: 'solar:skip-next-linear',
  sortAsc: 'solar:sort-from-bottom-to-top-linear',
  sortDesc: 'solar:sort-from-top-to-bottom-linear',
  sortReset: 'hugeicons:circle-arrow-data-transfer-diagonal',
  star: 'solar:star-bold',
  startup: 'solar:garage-linear',
  statusUrl: 'solar:station-minimalistic-broken',
  subscription: 'solar:dollar-linear',
  supportChat: 'solar:chat-round-check-linear',
  supportDemo: 'hugeicons:customer-support',
  team: 'solar:users-group-rounded-linear',
  trash: 'solar:trash-bin-minimalistic-linear',
  update: 'solar:star-fall-bold-duotone',
  updates: 'solar:notebook-bookmark-linear',
  updatesUrl: 'solar:widget-add-linear',
  url: 'solar:link-circle-linear',
  usage: 'solar:watch-square-minimalistic-charge-bold-duotone',
  useCases: 'solar:notebook-bookmark-linear',
  user: 'solar:user-hands-outline',
  userCheck: 'solar:user-check-rounded-linear',
  utilities: 'solar:airbuds-case-charge-linear',
  warning: 'solar:shield-warning-linear',
  webhook: 'solar:bolt-circle-linear',
  yes: 'hugeicons:checkmark-circle-03',

  // Attributes
  address: 'solar:streets-map-point-linear',
  apps: 'solar:laptop-minimalistic-linear',
  businessType: 'mdi:briefcase-outline',
  city: 'solar:streets-map-point-linear',
  contacts: 'solar:phone-calling-linear',
  continent: 'solar:globus-outline',
  country: 'solar:flag-linear',
  county: 'solar:signpost-2-linear',
  domainTld: 'solar:link-circle-linear',
  industries: 'hugeicons:factory-02',
  industryNaics: 'solar:bookmark-square-minimalistic-outline',
  industrySic: 'solar:bookmark-square-outline',
  jobTitles: 'solar:suitcase-outline',
  locked: 'solar:lock-keyhole-minimalistic-bold-duotone',
  logo: 'hugeicons:image-01',
  mainIndustry: 'hugeicons:factory',
  monthlyVisitors: 'solar:chart-linear',
  name: 'solar:buildings-2-linear',
  phoneNumber: 'solar:phone-calling-linear',
  plane: 'solar:plain-2-bold-duotone',
  revenue: 'solar:money-bag-linear',
  socialNetworks: 'solar:share-circle-linear',
  state: 'solar:map-linear',
  stockExchanges: 'hugeicons:apple-stocks',
  stockSymbol: 'solar:sticker-square-linear',
  technologies: 'solar:atom-linear',
  technologyCategory: 'solar:folder-favourite-bookmark-outline',
  totalEmployees: 'solar:users-group-two-rounded-linear',
  unlocked: 'solar:lock-keyhole-minimalistic-unlocked-bold-duotone',
  yearFounded: 'solar:calendar-date-linear',

  // Apps
  amazon: 'mdi:amazon',
  android: 'mdi:android',
  chrome: 'mdi:google-chrome',
  ios: 'mdi:apple-ios',
  mac: 'mdi:apple-finder',
  meta: 'hugeicons:meta',
  microsoft: 'mdi:microsoft',
  playstation: 'mdi:sony-playstation',
  xbox: 'mdi:microsoft-xbox',

  // Code languages
  csharp: 'nonicons:c-sharp-16',
  go: 'nonicons:go-16',
  java: 'nonicons:java-16',
  javascript: 'nonicons:javascript-16',
  php: 'nonicons:php-16',
  python: 'nonicons:python-16',
  ruby: 'nonicons:vim-replace-mode-16',
  rust: 'nonicons:rust-16',
  typescript: 'nonicons:typescript-16',

  // Contacts
  contactUrl: 'solar:link-circle-linear',
  emails: 'solar:mailbox-linear',
  lines: 'hugeicons:line',
  phones: 'solar:phone-linear',
  whatsapps: 'hugeicons:whatsapp',

  // Features
  enrichmentFeature: 'hugeicons:folder-search',
  searchFeature: 'hugeicons:global-search',
  similarityFeature: 'hugeicons:maps-search',

  // Maths
  and: 'carbon:chart-venn-diagram',
  equal: 'hugeicons:equal-sign',
  exactEqual: 'hugeicons:equal-sign-circle',
  greater: 'hugeicons:greater-than',
  less: 'hugeicons:less-than',
  notEqual: 'hugeicons:not-equal-sign',
  or: 'ph:union-bold',
  startsWith: 'solar:align-left-linear',

  // Social Networks
  discord: 'hugeicons:discord',
  dribbble: 'hugeicons:dribbble',
  facebook: 'hugeicons:facebook-01',
  github: 'hugeicons:github',
  gmail: 'mdi:gmail',
  instagram: 'hugeicons:instagram',
  linkedin: 'hugeicons:linkedin-01',
  linkedinSalesNavigator: 'solar:compass-linear',
  mastodon: 'mdi:mastodon',
  pinterest: 'hugeicons:pinterest',
  snapchat: 'hugeicons:snapchat',
  tiktok: 'hugeicons:tiktok',
  twitter: 'hugeicons:new-twitter',
  youtube: 'hugeicons:youtube',

  // Integrations
  make: 'tca:make',
  mcp: 'tca:mcp',
  n8n: 'tca:n8n',
  slack: 'hugeicons:slack',
  zapier: 'tca:zapier',
} as const

export function getIcon(attribute: keyof typeof icons) {
  return icons[attribute] || icons.default
}

export type UIcon = keyof typeof icons

export type UIconValues = typeof icons[UIcon]
